export default __webpack_public_path__ + "static/media/microcapilar_3.e47906e9.jpg";